import Link from "next/link";
import React from "react";
import {translate} from "components/common/Translate/Translate";

const DontHaveAnAccount = ({ enableRecover = true }: { enableRecover?: boolean }) => {
    return (
        <p className="text-sm text-center text-gray-600">
            <span className="dark:text-white">{translate('dont-have-an-account')}</span>
            <Link href="/pricing" className="ml-1 text-indigo-500 hover:underline">
                {translate('signup')}
            </Link>
            {enableRecover && (
                <>
                    <br />
                    <span className="dark:text-white">{translate('forgot-password')}</span>
                    <Link href="/auth/forget" className="ml-1 text-indigo-500 hover:underline">
                        {translate('recover-password')}
                    </Link>
                </>
            )}
        </p>
    );
};

export default DontHaveAnAccount;
